const GetStatusColor = ({ status }) => {
  const STATUS_COLORS = {
    available: {
      color: "#12D377",
      text: "Available",
      icon: "/assets/greenTick.svg",
    },
    faulted: { color: "#F94054", text: "Faulted", icon: "/assets/faulted.svg" },
    notcompatible: {
      color: "#F94054",
      text: "Not Compatible",
      icon: "/assets/notCompatible.svg",
    },
    disconnected: {
      color: "#EAA114",
      text: "Disconnected",
      icon: "/assets/Disconnected.svg",
    },
    unavailable: {
      color: "#EAA114",
      text: "Unavailable",
      icon: "/assets/Disconnected.svg",
    },
    charging: {
      color: "#0430C0",
      text: "Charging",
      icon: "/assets/Charging.svg",
    },
    gunconnected: {
      color: "#0430C0",
      text: "Gun Connected",
      icon: "/assets/Gunconnected.svg",
    },
    finished: {
      color: "#0430C0",
      text: "Finished",
      icon: "/assets/Finished.svg",
    },
  };

  const normalizedStatus = status?.toLowerCase().replace(/\s+/g, "");

  const statusInfo = STATUS_COLORS[normalizedStatus];

  if (!statusInfo) return null;

  const commonTextStyle = {
    fontWeight: "400",
    fontSize: "14px",
    color: statusInfo.color,
  };

  const commonImageStyle = {
    height: "10px",
    width: "10px",
  };

  return (
    <div>
      <span style={commonTextStyle}>{statusInfo.text}</span>
      <span style={{ marginLeft: "4px" }}>
        <img
          src={statusInfo.icon}
          alt={statusInfo.text}
          style={commonImageStyle}
        />
      </span>
    </div>
  );
};

export default GetStatusColor;
